export const REQUEST_INCIDENTS = "@@INCIDENTS/REQUEST_INCIDENTS";
export const SUCCESS_INCIDENTS = "@@INCIDENTS/SUCCESS_INCIDENTS";
export const FAILURE_INCIDENTS = "@@INCIDENTS/FAILURE_INCIDENTS";

export const REQUEST_INCIDENT_BY_ID = "@@INCIDENT_BY_ID/REQUEST_INCIDENT_BY_ID";
export const SUCCESS_INCIDENT_BY_ID = "@@INCIDENT_BY_ID/SUCCESS_INCIDENT_BY_ID";
export const FAILURE_INCIDENT_BY_ID = "@@INCIDENT_BY_ID/FAILURE_INCIDENT_BY_ID";

export default (state: any, action: any) => {
  let loadingPool = state.loadingPool;

  switch (action.type) {
    case REQUEST_INCIDENTS:
      state.loadingPool.push(action.type);
      return {
        ...state,
        // vehicles: [],
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_INCIDENTS:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_INCIDENTS
      );
      return {
        ...state,
        incidents: action.payload,
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_INCIDENTS:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_INCIDENTS
      );
      return {
        ...state,
        incidents: [],
        loadingPool,
        loading: !!loadingPool.length,
      };

    case REQUEST_INCIDENT_BY_ID:
      state.loadingPool.push(action.type);
      return {
        ...state,
        incident: {},
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_INCIDENT_BY_ID:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_INCIDENT_BY_ID
      );

      return {
        ...state,
        incident: action.payload,
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_INCIDENT_BY_ID:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_INCIDENT_BY_ID
      );

      return {
        ...state,
        incident: {},
        loadingPool,
        loading: !!loadingPool.length,
      };

    default:
      return state;
  }
};
